// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"toggle_wrapper___toggleWrapper___f0b7a979","label":"toggle_wrapper___label___d7ec37df"};